module.exports = __webpack_public_path__ + "static/img/13.6fc5269.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/sp/13.png
// module id = driB
// module chunks = 0